import { cancel, decideGate, events, get, getReviewCapability, list, refreshReviewCapability, submit, topup, } from './client';
import { watch } from './watch';
/**
 * Registered first-party product surfaces only, with
 * one exact Drafted exception for delegated review/decision routes. Other
 * generated-app origins remain blocked; server-side callers are unaffected.
 */
export const builds = {
    submit,
    get,
    getReviewCapability,
    events,
    cancel,
    decideGate,
    refreshReviewCapability,
    topup,
    list,
    watch,
};
export { BuildsApiError } from './client';
export * from './types';
